/**
 * Two initials at most, from the first and the last word: a middle name is dropped, so
 * "Kovács Levente Ádám" is KÁ. Empty when there is no name to take them from.
 */
export const initialsOf = (name) => {
  const words = (name || "").trim().split(/\s+/).filter(Boolean);

  if (words.length === 0) return "";

  const letters = words.length === 1
    ? [words[0][0]]
    : [words[0][0], words[words.length - 1][0]];

  return letters.join("").toUpperCase();
};
